// extracted by mini-css-extract-plugin
module.exports = {"sagaContainer":"Edge_sagaContainer__1iC2N"};